import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs";
import FeaturesPage from "./pages/FeaturesPage";
import FAQ from "./pages/FAQ";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import HelpCenter from "./pages/HelpCenter";
import HelpArticle from "./pages/HelpArticle";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import FeatureLanding from "./pages/FeatureLanding";
import FeatureArticle from "./pages/FeatureArticle";
import Compare from "./pages/Compare";
import CompareArticle from "./pages/CompareArticle";
import UseCases from "./pages/UseCases";
import UseCaseArticle from "./pages/UseCaseArticle";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            {/* Core Pages */}
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/features" element={<FeaturesPage />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsConditions />} />
            
            {/* Help Center */}
            <Route path="/help" element={<HelpCenter />} />
            <Route path="/help/:slug" element={<HelpArticle />} />
            
            {/* Blog */}
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            
            {/* Feature Landing Pages */}
            <Route path="/feature" element={<FeatureLanding />} />
            <Route path="/feature/:slug" element={<FeatureArticle />} />
            
            {/* Comparison Pages */}
            <Route path="/compare" element={<Compare />} />
            <Route path="/compare/:slug" element={<CompareArticle />} />
            
            {/* Use Case Pages */}
            <Route path="/use-case" element={<UseCases />} />
            <Route path="/use-case/:slug" element={<UseCaseArticle />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
